export const flatMap = (arr,f) => arr.flatMap(f)
export const set = (arr,idx,el) => {
  const newArr = [...arr]
  newArr[idx]=el
  return newArr
}
